export const radiansToDegrees = (rad) => (rad * 180) / Math.PI;
